import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { ServiceService } from '../service.service';
import { FormGroup, FormArray } from '@angular/forms';
import * as XLSX from 'xlsx';
import { ChartData, ChartOptions, ChartType, elements } from 'chart.js';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonFunctionsService {
private filterFormState: any = null;
  private clickedLabelSource = new BehaviorSubject<any | null>(null);
  clickedLabel$ = this.clickedLabelSource.asObservable();

  

  sendClickedLabel(label: any) {
    this.clickedLabelSource.next(label);
  }

  checkedList: any = [];
  allChecked: boolean = false
  constructor(private apiService: ServiceService) { }


saveFilterFormState(state: any) {
  this.filterFormState = state;
}

getFilterFormState() {
  return this.filterFormState;
}
  CheckedAll_box(event: any, output: any) {
    if (event.srcElement.checked) {
      this.checkedList = output.map((item: any) => item._id);
      this.allChecked = true
    } else {
      this.checkedList = [];
      this.allChecked = false
    }
    return {
      allChecked: this.allChecked,
      checkedList: this.checkedList
    };
  }

  Checked_box(value: any, event: any) {
    if (event.srcElement.checked) {

      const existingIndex = this.checkedList.findIndex((item: any) => item === value);
      if (existingIndex === -1) {
        this.checkedList.push(value);
      }
    } else {

      const existingIndex = this.checkedList.findIndex((item: any) => item === value);
      if (existingIndex !== -1) {
        this.checkedList.splice(existingIndex, 1);
      }
    }
    return this.checkedList
  }

  //alert
  alertFunction(title: string, text: string, icon: SweetAlertIcon) {
    Swal.fire({
      title: title,
      text: text,
      icon: icon
    });
  }

  // file Upload fn

  uploadFile(file: any, type: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const datas: File = file.files[0];
      const formData = new FormData();
      formData.append('file', datas);

      this.apiService.FileUopload(formData).subscribe(
        (res) => {
          console.log("uploaded", res);
          if (res.success) {
            this.apiService.showToast('success', "uploaded successfully");
          } else {
            this.apiService.showToast('error', "upload failed");
          }
          resolve(res); // Return the response here
        },
        (err) => {
          alert(err.statusText);
          reject(err); // Reject with error
        }
      );
    });
  }

  /**
     * Export multiple arrays as separate sheets in a single Excel file.
     * @param sheets Array of objects: { data: any[], sheetName: string, mapFn?: (item: any) => any }
     * @param fileName Name of the Excel file
     */
exportMultipleSheetsToExcel(
  sheets: {
    data: any[] | any[][],
    sheetName: string,
    format?: 'json' | 'aoa',
    mapFn?: (item: any) => any
  }[],
  fileName: string = 'Export.xlsx'
) {
  const wb = XLSX.utils.book_new();

  sheets.forEach(sheet => {
    let ws;
    if (sheet.format === 'aoa') {
      ws = XLSX.utils.aoa_to_sheet(sheet.data as any[][]);
    } else {
      const data = sheet.mapFn ? (sheet.data as any[]).map(sheet.mapFn) : sheet.data;
      ws = XLSX.utils.json_to_sheet(data as any[]);
    }
    XLSX.utils.book_append_sheet(wb, ws, sheet.sheetName);
  });

  XLSX.writeFile(wb, fileName);
}


  // form debugger fn
  logInvalidControls(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        // Recursively check nested FormGroups
        this.logInvalidControls(control);
      } else if (control instanceof FormArray) {
        // Check each FormGroup in the FormArray
        control.controls.forEach((group, index) => {
          if (group instanceof FormGroup) {
            console.log(`FormArray[${index}]`);
            this.logInvalidControls(group);
          }
        });
      } else if (control?.invalid) {
        console.log(`Invalid Control: ${key}, Errors:`, control.errors);
      }
    });
  }


 

  chartConfig(type: ChartType, position: 'top' | 'left' | 'bottom' | 'right'): ChartOptions {
  return {
    responsive: true,
    aspectRatio: 2,
    plugins: {
      legend: {
        position: position
      }
    }
  };
}


// excel export fn
exportExcel(
  sheets: { id: string; name?: string }[],
  fileName: string = 'Export.xlsx'
) {
  const wb = XLSX.utils.book_new();

  sheets.forEach((sheet, index) => {
    const table = document.getElementById(sheet.id);
    if (table) {
      const ws = XLSX.utils.table_to_sheet(table);
      const sheetName = sheet.name || `Sheet ${index + 1}`;
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    } else {
      console.warn(`Table with ID "${sheet.id}" not found.`);
    }
  });

  XLSX.writeFile(wb, fileName);
}

// employee analysis 
calculateAttendanceStats(data: any[]) {
  const total = data.length;
  const presentCount = data.filter(d => d.attendance_status?.trim().toLowerCase() === 'present').length;
  const absentCount = data.filter(d => d.attendance_status?.trim().toLowerCase() === 'absent').length;

  const presentPercentage = total ? Math.round(((presentCount / total) * 100)) : 0;
  const absentPercentage = total ? Math.round(((absentCount / total) * 100)) : 0;

  return {
    total,
    presentCount,
    absentCount,
    presentPercentage,
    absentPercentage
  };
}

  // grouping data
  employeeData: any[] = [];
  setData(data: any[]) {
    this.employeeData = data;
  }


  groupAttendanceByEmployee(data: any[]) {
  const grouped = new Map<string, any>();

  for (const record of data) {
    const { employee_id, employee_name, department, ...attendanceDetails } = record;

    if (!grouped.has(employee_id)) {
      grouped.set(employee_id, {
        employee_id,
        employee_name,
        department,
        attendance: []
      });
    }

    grouped.get(employee_id).attendance.push(attendanceDetails);
  }

  return Array.from(grouped.values());
}










  }
